const instructions = "Listed below are several types of patterns of problematic thinking that people use in different life situations. These patterns often become automatic, habitual thoughts that cause us to engage in self-defeating behavior. Considering your own stuck points, find examples for each of these patterns. Write in the stuck point under the appropriate pattern and describe how it fits that pattern. Think about how that pattern affects you."

const titles = [
	"Jumping to conclusions or predicting the future?",
	"Exaggerating or minimizing a situation (blowing things way out of proportion or shrinking their importance inappropriately).",
	"Ignoring important parts of a situation.",
	"Oversimplifying things as good/bad or right/wrong.",
	"Over-generalizing from a single incident (a negative event is seen as a never-ending pattern).",
	"Mind reading (you assume people are thinking negatively of you when there is no definite evidence for this).",
	"Emotional reasoning (using your emotions as proof, e.g. \"I feel fear so I must be in danger\")",
]

export function createPatternsOfProblematicThinkingConfig() {
	return {
		title: "Patterns of Problematic Thinking Worksheet",
		instructions,
		categorizationMode: "collaborative",
		categoryQuestion: "Which thinking patterns may fit this thought?",
		categorySectionTitle: "Thinking patterns",
		uncategorizedTitle: "Uncategorized or uncertain",
		removedCategoryMessage: "Previous pattern selection is no longer in this template",
		uncertaintyQuestion: "I am unsure which pattern fits",
		reviewTitle: "Thinking pattern profile",
		focusQuestion: "Which reviewed pattern will you address next?",
		showPriorResults: true,
		stages: [{
			id: "thought_examples",
			title: "Thoughts and stuck points",
			description: "",
			itemLabel: "Write a stuck point or thought. Describe the situation in your own words.",
			itemPlaceholder: "A thought that came up",
			allowAlternatives: false,
			categories: titles.map((title, index) => ({id: `pattern_${index + 1}`, title, description: ""})),
			itemFields: [
				{id: "fit", title: "How does it fit the pattern?", responseType: "multiline"},
				{id: "effect", title: "How does this way of thinking affect you?", responseType: "multiline"},
				{id: "theme", title: "Related stuck point or trauma theme", responseType: "text"},
			],
		}],
	}
}

export function createPatternsOfProblematicThinkingDemoPayload() {
	return {stagedWorksheet: {stages: [{id: "thought_examples", items: [
		{id: "thought_1", text: "If I made one mistake at work, everyone will think I am incapable.", values: {categoryIds: ["pattern_1"], fit: "I assumed what everyone would think before anyone said anything.", effect: "I avoided asking for feedback.", theme: "I cannot make mistakes."}},
		{id: "thought_2", text: "My friend was quiet, so she must be angry with me.", values: {categoryIds: ["pattern_1", "pattern_6"], fit: "I guessed her thoughts and expected the worst.", effect: "I pulled away instead of checking in.", theme: "People will reject me."}},
		{id: "thought_3", text: "I feel afraid on the train, so it must be unsafe.", values: {categoryIds: ["pattern_7"], isUncertain: true, fit: "The feeling seemed like proof of danger.", effect: "I changed my route."}},
	]}]}}
}
